import Router from 'vue-router';
import store from '@/store';

export default (router: Router) => {
  router.beforeEach((to, from, next) => {
    const routeRecord = to.matched.find((record) => record.meta.requiredRoles);
    if (routeRecord) {
      if (!store.state.currentUser) {
        return window.location.href = `${
          process.env.VUE_APP_API_GATEWAY
        }/auth/mail`;
      }
      let access = false;
      store.state.currentUser.roles.forEach( (role) => {
        if (routeRecord.meta.requiredRoles.includes(role)) {
          return access = true;
        }
      });
      if (access) {
        next();
      } else {
        next({
          path: '/',
        });
      }
    } else {
      next();
    }
  });
};
